<div class="flex flex-col justify-between h-full">
  <div class="routes flex flex-col items-center gap-2 text-lg">
    <div
      class="w-full cursor-pointer px-[25px] py-2 group/link transition flex items-center"
      (click)="onHomeNavigate()"
    >
      <mat-icon
        class="material-symbols-outlined text-2xl mr-2 text-black-900 leading-6 dark:text-white"
        >home</mat-icon
      >
      <span
        class="text-[15px] text-black-900 group-hover/link:font-bold dark:text-white"
        >Home</span
      >
    </div>

    @if (userRole === UserRoles.Influencer) {
    <div
      class="w-full cursor-pointer px-[25px] py-2 group/link transition flex items-center"
      (click)="onNavigateInfluencerDashboard()"
    >
      <mat-icon
        class="material-symbols-outlined text-2xl mr-2 text-black-900 leading-6 dark:text-white"
        >sync_saved_locally</mat-icon
      >
      <span
        class="text-[15px] text-black-900 group-hover/link:font-bold dark:text-white"
        >Dashboard</span
      >
    </div>
    <div
      class="w-full cursor-pointer px-[25px] py-2 group/link transition flex items-center"
      (click)="onNavigateRaffles()"
    >
      <mat-icon
        class="material-symbols-outlined text-2xl mr-2 text-black-900 leading-6 dark:text-white"
        >star_shine</mat-icon
      >
      <span
        class="text-[15px] text-black-900 group-hover/link:font-bold dark:text-white"
        >My Raffles</span
      >
    </div>
    <div
      class="w-full cursor-pointer px-[25px] py-2 group/link transition flex items-center"
      (click)="onNavigatePolls()"
    >
      <mat-icon
        class="material-symbols-outlined text-2xl mr-2 text-black-900 leading-6 dark:text-white"
        >bar_chart</mat-icon
      >
      <span
        class="text-[15px] text-black-900 group-hover/link:font-bold dark:text-white"
        >My Polls</span
      >
    </div>
    <div
      class="w-full cursor-pointer px-[25px] py-2 group/link transition flex items-center"
      (click)="onNavigateSubscriptions()"
    >
      <mat-icon
        class="material-symbols-outlined text-2xl mr-2 text-black-900 leading-6 dark:text-white"
        >subscriptions</mat-icon
      >
      <span
        class="text-[15px] text-black-900 group-hover/link:font-bold dark:text-white"
        >My Subscription</span
      >
    </div>
    <div
      class="w-full cursor-pointer px-[25px] py-2 group/link transition flex items-center"
      (click)="onNavigatePosts()"
    >
      <mat-icon
        class="material-symbols-outlined text-2xl mr-2 text-black-900 leading-6 dark:text-white"
        >image</mat-icon
      >
      <span
        class="text-[15px] text-black-900 group-hover/link:font-bold dark:text-white"
        >My Posts</span
      >
    </div>
    }
    
    @if(userRole === UserRoles.User) {
    <hr />
    <div
      class="w-full cursor-pointer px-[25px] py-2 group/link transition flex items-center"
      (click)="onNavigateTickets()"
    >
      <mat-icon
        class="material-symbols-outlined text-2xl mr-2 text-black-900 leading-6 dark:text-white"
        >confirmation_number</mat-icon
      >
      <span
        class="text-[15px] text-black-900 group-hover/link:font-bold dark:text-white"
        >Your Tickets</span
      >
    </div>
    }
  </div>

  <div class="functionality flex flex-col items-center gap-2 text-lg">
    <div
      class="w-full cursor-pointer px-[25px] py-2 group/link transition flex items-center"
      (click)="onEnableDarkTheme()"
    >
      <mat-icon
        class="material-symbols-outlined text-2xl mr-2 text-black-900 leading-6 dark:text-white"
        >{{
          appStateService.userPreferences().darkMode
            ? "light_mode"
            : "dark_mode"
        }}</mat-icon
      >
      <span
        class="text-[15px] text-black-900 group-hover/link:font-bold dark:text-white"
      >
        {{
          appStateService.userPreferences().darkMode
            ? "Light Theme"
            : "Dark Theme"
        }}</span
      >
    </div>
    @if (currentUserInfo && userRole === UserRoles.Influencer) {
    <div
      class="w-full cursor-pointer px-[25px] py-2 group/link transition flex items-center"
      (click)="onNavigateUserProfile()"
    >
      <mat-icon
        class="material-symbols-outlined text-2xl mr-2 text-black-900 leading-6 dark:text-white"
        >person</mat-icon
      >
      <span
        class="text-[15px] text-black-900 group-hover/link:font-bold dark:text-white"
        >My Profile</span
      >
    </div>
    } @if (currentUserInfo) {
    <div
      class="w-full cursor-pointer px-[25px] py-2 group/link transition flex items-center"
      (click)="onSignOut()"
    >
      <mat-icon
        class="material-symbols-outlined text-2xl mr-2 text-black-900 leading-6 dark:text-white"
        >logout</mat-icon
      >
      <span
        class="text-[15px] text-black-900 group-hover/link:font-bold dark:text-white"
        >Sign Out</span
      >
    </div>
    } @if (!currentUserInfo) {
    <div
      class="w-full cursor-pointer px-[25px] py-2 group/link transition flex items-center"
      (click)="onNavigateSignIn()"
    >
      <mat-icon
        class="material-symbols-outlined text-2xl mr-2 text-black-900 leading-6 dark:text-white"
        >login</mat-icon
      >
      <span
        class="text-[15px] text-black-900 group-hover/link:font-bold dark:text-white"
        >Sign In</span
      >
    </div>
    }
  </div>
</div>
